<template>
  <div>
    <div class="introduce-box">
      <img src="../assets/image/shang@2x.png" alt="">
      <div class="des-box" >
        <div class="des" v-html="description">
        </div>
      </div>
      <img class="bottom" src="../assets/image/xia@2x.png" alt="">
    </div>
  </div>
</template>
<script>
import { getActivityDetail } from '@/http/index';
export default {
  name: "Introduce",
  data() {
    return {
      description: ""
    };
  },
  created() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      let params = {
        token: ""
      }
      getActivityDetail(params).then(res => {
        if (res) {
          this.description = res.data.description
        }
      })
    },
  },
};
</script>
<style scoped>
.introduce-box {
  margin-left: 10px;
}
.introduce-box img {
  display: block;
}
.des-box {
  /* padding: 20px 13px 70px 20px; */
  padding: 0 25px 0 20px;
  width: 100%;
  background: url('../assets/image/zhong@2x.png') no-repeat;
  background-size: 100% 100%;
  transform: translateY(-4px);
}
.bottom {
  transform: translateY(-60px);
}
.des {
  padding: 0 25px 0 20px;
  transform: translateY(-120px);
}

</style>